var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"package"},[_c('HeaderComponent'),_c('Payments'),_c('FooterComponent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }